import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const ChevronUp = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M35.6839 28.7295C35.281 29.1073 34.6482 29.0869 34.2705 28.6839L20 13.4621L5.72954 28.6839C5.3518 29.0869 4.71897 29.1073 4.31606 28.7295C3.91315 28.3518 3.89273 27.719 4.27046 27.3161L19.2705 11.3161C19.4595 11.1144 19.7236 11 20 11C20.2764 11 20.5405 11.1144 20.7295 11.3161L35.7295 27.3161C36.1073 27.719 36.0868 28.3518 35.6839 28.7295Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default ChevronUp;
